<template>
    <div id="footer-wrapper" class="fixed-bottom">
        <b-container style="max-width: 1300px; padding-top: 20px">
            <b-row style="padding-left: 20px">
                <b-col sm="4">
                    <b-row>
                        <a href="http://www.army.gr/" target="_blank"
                           style="color:white; font-weight:bold; float: left">Γενικό
                            Επιτελείο Στρατού</a><br>
                    </b-row>
                    <b-row>
                        <p style="color:white; text-align: left">&copy; 2021. Με την επιφύλαξη παντός νομίμου
                            δικαιώματος.</p>
                    </b-row>
                    <b-row>
                        <p style="color:white; text-align: left">Έκδοση: {{version}}</p>
                    </b-row>
                    <b-row>
                        <p style="color:#0072C6; text-align: left; font-size: 5px">ΛΕΛΑ</p>
                    </b-row>
                </b-col>
                <b-col sm="4" offset-sm="4">
                    <b-row>
                    <p style="color:white; float: left"><a href="http://army.gr/default.php?pname=kepyes_certifications&amp;la=1"
                           title="ΕΝ ISO 27001:2005 Certified" target="_blank">
                            <img height="35" alt="kepyes_iso" src="/files/iso_kepyes.png" class="iso-kepyes-Image">
                        </a>
                        &nbsp;&nbsp;&nbsp;Ανάπτυξη <a style="cursor:pointer; color:#fff;"
                                                      href="http://www.army.gr/default.php?pname=kepyes&amp;la=1"
                                                      target="_blank"><strong><span style="color: #fff;">&nbsp;ΚΕ.Π.Υ.Ε.Σ</span></strong></a>
                            &copy; 2009-2021</p></b-row>
                    <b-row>
                        <p  style="color:white; text-align: left">Το ΚΕ.Π.Υ.Ε.Σ εφαρμόζει Πιστοποιημένο Σύστημα<br> Διαχείρισης Ασφάλειας
                        Πληροφοριών
                            <span style="color:#fff;font-weight:bold;">&nbsp; EN ISO 27001:2013</span></p>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        name: "footerpage",
        computed: {
            version() {
                return process.env.VUE_APP_VERSION
            },
        }
    }
</script>

<style scoped>
    #footer-wrapper{
        position: unset!important;
        background:#0072C6;
    }
</style>